angular.module('genesisApp')
  .controller('AdminDashboardController', function () {
    console.log('AdminDashboardController...');
  })
;

